import { Skeleton } from "antd";
import React from "react";

/**
 * A calendar-grid skeleton loader using Ant Design Skeleton tiles.
 * Drop-in replacement for the previous react-content-loader SVG implementation.
 *
 * Props (backward-compatible — all call-sites work unchanged):
 *  - row          {number}         number of grid rows           (default: 3)
 *  - column       {number}         number of grid columns         (default: 7)
 *  - heading      {object|null}    pass falsy to hide heading row (default: shown)
 *  - width        silently ignored — layout is responsive via CSS grid
 *  - padding      silently ignored — handled via gap/padding CSS
 *  - borderradius silently ignored — hardcoded to 10px for visual parity
 */
const DashboardShiftScheduleLoader = ({
  row = 3,
  column = 7,
  heading = { width: "60%", height: 24 },
  ...props
}) => {
  const cells = Array.from({ length: row * column });

  return (
    <div style={{ width: "100%", padding: 8 }} {...props}>
      {/* Optional heading row */}
      {heading && (
        <Skeleton.Input
          active
          size="small"
          style={{
            width: heading.width ?? "60%",
            height: heading.height ?? 24,
            marginBottom: 12,
            borderRadius: 4,
            display: "block",
          }}
        />
      )}

      {/* Calendar day-cell grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${column}, 1fr)`,
          gap: 7,
        }}
      >
        {cells.map((_, i) => (
          <Skeleton.Button
            key={i}
            active
            shape="square"
            style={{
              width: "100%",
              height: "auto",
              aspectRatio: "1 / 1",
              borderRadius: 10,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default DashboardShiftScheduleLoader;
